import styled from 'styled-components';

export const FormContainer = styled.div`
  border: 1px solid #4b286d;
  border-radius: 8px;
  padding: 2rem;
  margin-bottom: 2rem;
`;

export const TableContainer = styled.div`
  margin-top: 2rem;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
`;

export const Thead = styled.thead`
  background-color: #f5f5f5;
`;

export const Tr = styled.tr`
  border-bottom: 1px solid #e4e4e4;
  
  &:hover {
    background-color: #f8f9fa;
  }
`;

export const Th = styled.th`
  padding: 1rem;
  text-align: left;
  font-weight: 600;
  color: #333;
  border-bottom: 2px solid #4b286d;
`;

export const Td = styled.td`
  padding: 1rem;
  vertical-align: top;
`;

export const ActionButton = styled.button`
  background: #4b286d;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 0.5rem;
  font-size: 0.875rem;
  
  &:hover {
    background: #3a1f56;
  }
`;

export const DeleteButton = styled.button`
  background: #dc3545;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.875rem;
  
  &:hover {
    background: #c82333;
  }
`;

export const SaveButton = styled.button`
  background: #2b8000;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  
  &:hover {
    background: #2b8000;
  }
`;

export const SelectedChip = styled.span`
  display: inline-flex;
  align-items: center;
  background: #e9ecef;
  color: #495057;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.875rem;
  margin: 0.125rem;
  border: 1px solid #ced4da;
  gap: 0.25rem;
`;

export const ChipRemoveButton = styled.button`
  background: none;
  border: none;
  color: #6c757d;
  cursor: pointer;
  padding: 0;
  margin-left: 0.25rem;
  font-size: 0.75rem;
  line-height: 1;
  
  &:hover {
    color: #dc3545;
  }
`;

export const MultiSelectContainer = styled.div`
  position: relative;
  border: 1px solid #ced4da;
  border-radius: 4px;
  background: white;
  min-height: 2.5rem;
  padding: 0.5rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.25rem;
  
  &:focus-within {
    border-color: #4b286d;
    box-shadow: 0 0 0 0.2rem rgba(75, 40, 109, 0.25);
  }
`;

export const MultiSelectInput = styled.input`
  border: none;
  outline: none;
  flex: 1;
  min-width: 120px;
  padding: 0.25rem;
  font-size: 0.875rem;
  
  &::placeholder {
    color: #6c757d;
  }
`;

export const MultiSelectActions = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
  gap: 0.5rem;
`;

export const ClearButton = styled.button`
  background: none;
  border: none;
  color: #6c757d;
  cursor: pointer;
  padding: 0.25rem;
  font-size: 0.875rem;
  
  &:hover {
    color: #dc3545;
  }
`;

export const DropdownArrow = styled.div`
  color: #6c757d;
  font-size: 0.875rem;
  cursor: pointer;
  padding: 0.25rem;
  
  &:hover {
    color: #4b286d;
  }
`;

export const DropdownContainer = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ced4da;
  border-top: none;
  border-radius: 0 0 4px 4px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const DropdownOption = styled.div`
  padding: 0.5rem;
  cursor: pointer;
  font-size: 0.875rem;
  
  &:hover {
    background: #f8f9fa;
  }
  
  ${props => props.selected && `
    background: #e3f2fd;
    color: #1976d2;
  `}
`;

export const FieldOptionsGroup = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
  margin-bottom: 1.5rem;
`;

export const ResponsiveTableContainer = styled.div`
  overflow-x: auto;
  border: 1px solid #e4e4e4;
  
  .responsive-table-container {
    min-width: 2800px;
  }
  
  .responsive-table {
    width: 100%;
    min-width: 2800px;
    border-collapse: collapse;
  }
  
  .responsive-table__caption {
    padding: 1rem;
    background: #4b286d;
    color: white;
    font-weight: 600;
    border-bottom: 1px solid #e4e4e4;
    text-align: left;
  }
  
  .responsive-table__thead {
    background: #f5f5f5;
  }
  
  .responsive-table__thead th {
    padding: 1rem;
    text-align: center;
    font-weight: 600;
    color: #333;
    border-bottom: 1px solid #e4e4e4;
    white-space: nowrap;
    background: #f5f5f5;
  }
  
  
  .responsive-table__tbody tr {
    border-bottom: 1px solid #e4e4e4;
  }
  
  .responsive-table__tbody tr:hover {
    background-color: #f8f9fa;
  }
  
  .responsive-table__tbody td {
    padding: 1rem;
    vertical-align: top;
  }
  
  
  .responsive-table__tbody tr {
    height: auto;
  }
  
  .responsive-table__actions {
    display: flex;
    gap: 0.5rem;
  }
  
  @media (max-width: 768px) {
    .responsive-table__thead {
      display: none;
    }
    
    .responsive-table__tbody tr {
      display: block;
      border: 1px solid #e4e4e4;
      border-radius: 8px;
      margin-bottom: 1rem;
      padding: 1rem;
    }
    
    .responsive-table__tbody td {
      display: block;
      padding: 0.5rem 0;
      border-bottom: 1px solid #f0f0f0;
    }
    
    .responsive-table__tbody td:before {
      content: attr(data-header-label) ": ";
      font-weight: 600;
      color: #333;
      display: inline-block;
      width: 40%;
    }
    
    .responsive-table__tbody td:last-child {
      border-bottom: none;
    }
  }
`;

export const AnswerField = styled.div`
  margin-bottom: 1rem;
  
  label {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: 500;
    color: #333;
  }
  
  input {
    width: 100%;
    padding: 0.5rem;
    border: 1px solid #ced4da;
    border-radius: 4px;
    font-size: 0.875rem;
  }
`;

export const AnswerChip = styled.span`
  display: inline-block;
  background: #e9ecef;
  color: #495057;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.875rem;
  margin: 0.125rem;
  border: 1px solid #ced4da;
`;

export const AnswerInput = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  
  input {
    flex: 1;
    padding: 0.5rem;
    border: 1px solid #ced4da;
    border-radius: 4px;
    font-size: 0.875rem;
  }
  
  button {
    background: #dc3545;
    color: white;
    border: none;
    padding: 0.25rem 0.5rem;
    border-radius: 4px;
    cursor: pointer;
    font-size: 0.875rem;
    
    &:hover {
      background: #c82333;
    }
  }
`;

export const AddAnswerButton = styled.button`
  background: #2b8000;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.875rem;
  margin-top: 0.5rem;
  
  &:hover {
    background: #2b8000;
  }
`;



export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ConfirmationModal = styled.div`
  background: white;
  border-radius: 8px;
  padding: 2rem;
  max-width: 400px;
  width: 90%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
`;

export const ModalTitle = styled.h3`
  margin: 0 0 1rem 0;
  color: #333;
  font-size: 1.25rem;
`;

export const ModalMessage = styled.p`
  margin: 0 0 2rem 0;
  color: #666;
  line-height: 1.5;
`;

export const ModalButtons = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
`;

export const ModalButton = styled.button`
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  border: none;
  
  ${props => props.variant === 'primary' && `
    background: #dc3545;
    color: white;
    
    &:hover {
      background: #c82333;
    }
  `}
  
  ${props => props.variant === 'secondary' && `
    background: #6c757d;
    color: white;
    
    &:hover {
      background: #5a6268;
    }
  `}
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 2rem;
`;

export const PaginationBar = styled.div`
  background: white;
  border-radius: 25px;
  padding: 0.5rem 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

export const PageButton = styled.button`
  background: ${props => props.active ? '#4b286d' : 'transparent'};
  color: ${props => props.active ? 'white' : '#333'};
  border: none;
  border-radius: 20px;
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  font-weight: ${props => props.active ? '600' : '400'};
  cursor: pointer;
  min-width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  
  &:hover {
    background: ${props => props.active ? '#4b286d' : '#f8f9fa'};
    color: ${props => props.active ? 'white' : '#4b286d'};
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const NavigationButton = styled.button`
  background: transparent;
  color: #4b286d;
  border: none;
  padding: 0.5rem;
  cursor: pointer;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 2rem;
  height: 2rem;
  transition: all 0.2s ease;
  
  &:hover {
    background: #f8f9fa;
    color: #3a1f56;
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;